<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSimpleStorageServiceResourceListData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../s3/TableExpand.vue";
var tableSimpleStorageServiceResourceVue = {};
export default {
  name: "TableSimpleStorageServiceResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      bucketNameSearchVal: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.StorageBin.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.binName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.bucketStorage"),
          key: "bucketStorage"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.launchTime"),
          key: "creationDateString"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.establishPerson"),
          key: "displayName"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.bucketLogging"),
          key: "bucketLogging"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.bucketLoggingUrl"),
          key: "bucketLoggingUrl"
        }
      ],
      tableSimpleStorageServiceResourceListData: []
    };
  },
  beforeCreate: function() {
    tableSimpleStorageServiceResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("bucketNameSearch", function(bucketNameSearchVal) {
      tableSimpleStorageServiceResourceVue.bucketNameSearchVal = bucketNameSearchVal;
    });
    eventBus.$on("companyId", function(val) {
      tableSimpleStorageServiceResourceVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSimpleStorageServiceResourceVue.getSimpleStorageServiceResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getSimpleStorageServiceResourceListData: function() {
      this.$api.resourceManagement
        .selectBucketByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: this.companyId,
          name: tableSimpleStorageServiceResourceVue.bucketNameSearchVal,
          accountType: 0
        })
        .then(res => {
          this.tableSimpleStorageServiceResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSimpleStorageServiceResourceVue.getSimpleStorageServiceResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSimpleStorageServiceResourceVue.getSimpleStorageServiceResourceListData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("bucketNameSearch");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/s3/TableSimpleStorageServiceResource.vue